function homeslider() {
	$('#lightSlider1,#lightSlider2').lightSlider({
		item: 3,
		loop: false,
		slideMove: 2,
		easing: 'cubic-bezier(0.25, 0, 0.25, 1)',
		speed: 600,
		responsive: [
			{
				breakpoint: 800,
				settings: {
					item: 2,
					slideMove: 1,
					slideMargin: 6,
				}
			},
			{
				breakpoint: 480,
				settings: {
					item: 1,
					slideMove: 1
				}
			}
		]
	});
}
function allslider() {
	$('#lightSlider').lightSlider({
		gallery: true,
		item: 1,
		loop: true,
		slideMargin: 0,
		thumbItem: 9,
		auto: true,
	});
	//responsive
	$('#responsive').lightSlider({
		item: 3,
		loop: false,
		slideMove: 2,
		easing: 'cubic-bezier(0.25, 0, 0.25, 1)',
		speed: 600,
		responsive: [
			{
				breakpoint: 800,
				settings: {
					item: 2,
					slideMove: 1,
					slideMargin: 6,
				}
			},
			{
				breakpoint: 480,
				settings: {
					item: 1,
					slideMove: 1
				}
			}
		]
	});
	// vertical-slider
	$('#vertical').lightSlider({
		gallery: true,
		item: 1,
		vertical: true,
		verticalHeight: 295,
		vThumbWidth: 50,
		thumbItem: 8,
		thumbMargin: 4,
		slideMargin: 0
	});
}
function fancyBox() {
	$(".fancybox").fancybox();
	// Change title type, overlay closing speed
	$(".fancybox-effects-a").fancybox({
		helpers: {
			title: {
				type: 'outside'
			},
			overlay: {
				speedOut: 0
			}
		}
	});

	// Disable opening and closing animations, change title type
	$(".fancybox-effects-b").fancybox({
		openEffect: 'none',
		closeEffect: 'none',

		helpers: {
			title: {
				type: 'over'
			}
		}
	});

	// Set custom style, close if clicked, change title type and overlay color
	$(".fancybox-effects-c").fancybox({
		wrapCSS: 'fancybox-custom',
		closeClick: true,

		openEffect: 'none',

		helpers: {
			title: {
				type: 'inside'
			},
			overlay: {
				css: {
					'background': 'rgba(238,238,238,0.85)'
				}
			}
		}
	});

	// Remove padding, set opening and closing animations, close if clicked and disable overlay
	$(".fancybox-effects-d").fancybox({
		padding: 0,

		openEffect: 'elastic',
		openSpeed: 150,

		closeEffect: 'elastic',
		closeSpeed: 150,

		closeClick: true,

		helpers: {
			overlay: null
		}
	});


	/*
	*  Button helper. Disable animations, hide close button, change title type and content
	*/

	$('.fancybox-buttons').fancybox({
		openEffect: 'none',
		closeEffect: 'none',

		prevEffect: 'none',
		nextEffect: 'none',

		closeBtn: false,

		helpers: {
			title: {
				type: 'inside'
			},
			buttons: {}
		},

		afterLoad: function () {
			this.title = 'Image ' + (this.index + 1) + ' of ' + this.group.length + (this.title ? ' - ' + this.title : '');
		}
	});


	/*
	 *  Thumbnail helper. Disable animations, hide close button, arrows and slide to next gallery item if clicked
	 */

	$('.fancybox-thumbs').fancybox({
		prevEffect: 'none',
		nextEffect: 'none',

		closeBtn: false,
		arrows: false,
		nextClick: true,

		helpers: {
			thumbs: {
				width: 50,
				height: 50
			}
		}
	});
}


function allCode() {
	if (window.location.href.indexOf('/light-slider') > 0) {
		allslider()
	}
	if (window.location.href.indexOf('/home') > 0) {
		homeslider()
	}
	if (window.location.href.indexOf('/fancy-box') > 0) {
		fancyBox()
	}
}

$(document).ready(function () {
	// NOTE  Show code js
	if (jQuery.isReady) {
		allCode()
	}
})


$(document).on("click", ".dropdown .dropdown_list, .dropdown .dropdown_btn, .menu_wrapper .logo,.uikit-cdn-btn", function () {
	allCode()
});

$(document).on("click", ".copy-cdn", function () {
	var $temp = $("<input>");
	$("body").append($temp);
	$temp.val($(this).text()).select();
	document.execCommand("copy");
	$temp.remove();
	var oldText = $(this).closest(".cdn-link").find(".notif-to-user").text();
	var that = $(this);
	$(this).closest(".cdn-link").find(".notif-to-user").text("Cdn is copied");
	setTimeout(function () {
		that.closest(".cdn-link").find(".notif-to-user").text(oldText);
	}, 2000);

});


// WEBPACK FOOTER //
// src/assets/js/custom.js